import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetReceiptJuniorPilotRequest,
  failGetReceiptJuniorPilot,
  setGetReceiptJuniorPilot,
  setGetReceiptJuniorPilotFromApi,
  updateGetReceiptJuniorPilot,
  updateGetReceiptJuniorPilotFromApi,
} from './get-receipt-junior-pilot.actions';

/**
 * Service to handle async GetReceiptJuniorPilot actions
 */
@Injectable()
export class GetReceiptJuniorPilotEffect {
  /**
   * Set the state with the reply content, dispatch failGetReceiptJuniorPilot if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetReceiptJuniorPilotFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetReceiptJuniorPilot({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetReceiptJuniorPilot({ error, requestId: action.requestId })),
        cancelGetReceiptJuniorPilotRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetReceiptJuniorPilot if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetReceiptJuniorPilotFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetReceiptJuniorPilot({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetReceiptJuniorPilot({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
